import { type RibbonIconColor } from "owa-command-ribbon/lib/util/ribbonIconModeColors";
import { type IconColorMap } from "owa-command-ribbon/lib/util/getRibbonIconColor";
import { type MailRibbonGroupId, type MailRibbonControlId } from "owa-ribbon-ids/lib/mailRibbonId";
import { type FormatControlId } from "owa-ribbon-ids/lib/formatControlId";
import { type ActionControlId } from "owa-ribbon-ids/lib/actionControlId";
import { HelpTabIconColorMap } from "owa-ribbon-help/lib/utils/helpTabIconColorMap";

export const MailIconColorMap: IconColorMap = new Map([
    [505, 3],
    [616, 4],
    [507, 0],
    [658, 0],
    [612, 0],
    [510, 3],
    [518, 4],
    [625, 3],
    [527, 0],
    [528, 2],
    [113, 4],
    [128, 0],
    [145, 4],
    [531, 0],
    [532, 4],
    [535, 2],
    [652, 4],
    [537, 4],
    [538, 3],
    [540, 4],
    [545, 4],
    [546, 2],
    [547, 0],
    [548, 4],
    [550, 2],
    [553, 5],
    [696, 5],
    [698, 5],
    [699, 5],
    [700, 5],
    [657, 0],
    [678, 5],
    [555, 4],
    [680, 4],
    [651, 4],
    [556, 5],
    [679, 5],
    [557, 5],
    [681, 5],
    [570, 4],
    [581, 4],
    [643, 4],
    [740, 0],
    
    /**************** meeting RSVP context menu controls ****************/
    [762, 3],
    [763, 0],
    [764, 5],
    [765, 5],
    
    /**************** format controls ****************/
    [6029, 2],
    [6011, 2],
    [6012, 2],
    
    /**************** action controls ****************/
    [638, 4],
    [623, 4],
    [506, 4],
    [7004, 3],
    [7029, 4],
    [639, 2],
    [7012, 2],
    [7011, 1],
    [7000, 4],
    [529, 1],
    [7005, 0],
    [560, 5],
    [7035, 5],
    [7051, 5],
    [7052, 5],
    [7041, 5],
    [7040, 4],
    [564, 4],
    [7042, 4],
    [7067, 4],
    [7053, 4],
    [7063, 0],
    
    /**************** help tab controls ****************/
    ...HelpTabIconColorMap,
]);
